export const FANTACY_STUDIO_URL = process.env.NEXT_PUBLIC_TIPSY_STUDIO_URL ?? ''
export const FANTACY_STUDIO_PATH = '/studio'
export const FANTACY_STUDIO_QUERY_PARAM = 'studioPath'
export const FANTACY_STUDIO_ROUTE_CHANGE_MESSAGE_TYPE =
  'tipsy-studio:route-change'
export const FANTACY_STUDIO_NAVIGATE_BACK_MESSAGE_TYPE =
  'tipsy-studio:navigate-back'
export const FANTACY_STUDIO_LANGUAGE_CHANGED_MESSAGE_TYPE =
  'tipsy-studio:language-changed'
export const FANTACY_STUDIO_UNAUTHORIZED_MESSAGE_TYPE =
  'tipsy-studio:unauthorized'

const DEFAULT_FANTACY_STUDIO_ROUTE = '/'
const FALLBACK_FANTACY_STUDIO_ORIGIN = 'https://studio.invalid'

export function normalizeFantacyStudioPath(value?: string | null): string {
  if (!value) {
    return DEFAULT_FANTACY_STUDIO_ROUTE
  }

  const candidate = value.trim()

  if (
    !candidate ||
    !candidate.startsWith('/') ||
    candidate.startsWith('//') ||
    /^[a-zA-Z][a-zA-Z\d+.-]*:/.test(candidate)
  ) {
    return DEFAULT_FANTACY_STUDIO_ROUTE
  }

  try {
    const parsed = new URL(candidate, FALLBACK_FANTACY_STUDIO_ORIGIN)

    if (parsed.origin !== FALLBACK_FANTACY_STUDIO_ORIGIN) {
      return DEFAULT_FANTACY_STUDIO_ROUTE
    }

    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return DEFAULT_FANTACY_STUDIO_ROUTE
  }
}

export function getFantacyStudioOrigin(): string | null {
  if (!FANTACY_STUDIO_URL) {
    return null
  }

  try {
    return new URL(FANTACY_STUDIO_URL).origin
  } catch {
    return null
  }
}

export function normalizeFantacyStudioMessagePath(
  value?: string | null
): string {
  if (!value) {
    return DEFAULT_FANTACY_STUDIO_ROUTE
  }

  const candidate = value.trim()
  const studioOrigin = getFantacyStudioOrigin()

  if (!candidate || !studioOrigin) {
    return normalizeFantacyStudioPath(candidate)
  }

  try {
    const studioUrl = new URL(studioOrigin)

    if (candidate === studioUrl.host) {
      return DEFAULT_FANTACY_STUDIO_ROUTE
    }

    if (candidate.startsWith(`${studioUrl.host}/`)) {
      return normalizeFantacyStudioPath(candidate.slice(studioUrl.host.length))
    }

    const parsed = new URL(candidate, studioOrigin)

    if (parsed.origin === studioOrigin) {
      return normalizeFantacyStudioPath(
        `${parsed.pathname}${parsed.search}${parsed.hash}`
      )
    }
  } catch {
    // Fall through to relative-path normalization.
  }

  return normalizeFantacyStudioPath(candidate)
}

export function buildFantacyStudioUrl(path?: string | null): string {
  if (!FANTACY_STUDIO_URL) {
    return ''
  }

  try {
    return new URL(
      normalizeFantacyStudioPath(path),
      FANTACY_STUDIO_URL
    ).toString()
  } catch {
    return FANTACY_STUDIO_URL
  }
}
